import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Highlighter from 'react-highlight-words';

import {
  PageSubTitle,
  Text,
  Heading,
  DateTime
} from 'components/common/Elements/Elements';

import classes from './AdditionalFeedBack.module.scss';

const AdditionalFeedBack = ({ data, searchText }) => {
  const { t } = useTranslation(['activity']);

  return (
    <>
      <PageSubTitle
        title={t('activity:qbr.CUSTOMER_FEEDBACK')}
        className={classes.title}
        size={2}
      />
      <div className={classes.children}>
        <div className={classes.labelInfoWrap}>
          <Heading>{`${t('activity:qbr.CUSTOMER_FEEDBACK')}:`}</Heading>
          <Text type={'p'} className={classes.infoText}>
            <Highlighter
              autoEscape
              highlightClassName={classes.highlight}
              searchWords={[searchText]}
              textToHighlight={data.customerFeedback}
            />
          </Text>
        </div>
        <div className={classes.labelInfoWrap}>
          <Heading>{`${t('activity:qbr.FEATURE_REQUEST')}:`}</Heading>
          <Text type={'p'} className={classes.infoText}>
            <Highlighter
              autoEscape
              highlightClassName={classes.highlight}
              searchWords={[searchText]}
              textToHighlight={data.featureRequest}
            />
          </Text>
        </div>
        <div className={classes.labelInfoWrap}>
          <Heading>{t('activity:qbr.NEXT_QBR_DATE')}</Heading>
          <Text type={'p'} className={classes.infoText}>
            <DateTime date={data.nextQbrDate} time />
          </Text>
        </div>
        <div className={classes.labelInfoWrap}>
          <Heading>{t('activity:qbr.RISK')}</Heading>
          <Text type={'p'} className={classes.infoText}>
            <Highlighter
              autoEscape
              highlightClassName={classes.highlight}
              searchWords={[searchText]}
              textToHighlight={data.risk}
            />
          </Text>
        </div>
        <div className={classes.labelInfoWrap}>
          <Heading>{`${t('activity:qbr.TECHNICAL_ISSUES')}:`}</Heading>
          <Text type={'p'} className={classes.infoText}>
            <Highlighter
              autoEscape
              highlightClassName={classes.highlight}
              searchWords={[searchText]}
              textToHighlight={data.technicalIssues}
            />
          </Text>
        </div>
        <div className={classes.labelInfoWrap}>
          <Heading>{t('activity:qbr.USE_CASE')}</Heading>
          <Text type={'p'} className={classes.infoText}>
            <Highlighter
              autoEscape
              highlightClassName={classes.highlight}
              searchWords={[searchText]}
              textToHighlight={data.useCase}
            />
          </Text>
        </div>
      </div>
    </>
  );
};

AdditionalFeedBack.propTypes = {
  data: PropTypes.object,
  searchText: PropTypes.string
};

export default AdditionalFeedBack;
